// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","menu":"Header_menu__bKlxq"};